// extracted by mini-css-extract-plugin
module.exports = {"richTextComponent":"RichTextWrapper_richTextComponent__MUKR9","js-has-pseudo":"RichTextWrapper_js-has-pseudo__bw1BW"};